// Utility to completely clear all authentication data from localStorage and sessionStorage
// This is a separate utility to ensure consistent auth cleanup across the app

export function clearAllAuthData() {
  try {
    // Clear all auth-related localStorage keys
    const localStorageKeysToRemove = [
      'ace-auth',           // AuthProvider user data
      'ace-auth-session',   // AuthService session data
      'password-recently-reset', // Reset flag
    ];
    
    localStorageKeysToRemove.forEach(key => {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        // Ignore individual key removal errors
      }
    });

    // Clear all profile and session-related sessionStorage keys
    const sessionStorageKeysToRemove = [
      'profile_data',       // Cached profile data
      'profile_cache_timestamp', // Profile cache timestamp
      'profile_strength',   // Profile completion strength
    ];
    
    sessionStorageKeysToRemove.forEach(key => {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
        // Ignore individual key removal errors
      }
    });
    
    // Also clear any user-specific keys that might exist in localStorage
    try {
      const allLocalKeys = Object.keys(localStorage);
      const userSpecificKeys = allLocalKeys.filter(key => 
        key.includes('profile_completion_dismissed_') ||
        key.includes('assessment_check_') ||
        key.includes('assessment_completed_') ||
        key.includes('assessment_skipped_') ||
        key.includes('comprehension_') ||
        key.includes('dialog_cooldown_') ||
        key.includes('last_user_id')
      );
      
      userSpecificKeys.forEach(key => {
        try {
          localStorage.removeItem(key);
        } catch (e) {
          // Ignore individual key removal errors
        }
      });
    } catch (e) {
      // Ignore errors when reading localStorage keys
    }

    // Clear any user-specific keys that might exist in sessionStorage
    try {
      const allSessionKeys = Object.keys(sessionStorage);
      const userSpecificSessionKeys = allSessionKeys.filter(key => 
        key.includes('profile_') ||
        key.includes('user_') ||
        key.includes('assessment_') ||
        key.includes('comprehension_') ||
        key.includes('chat_') ||
        key.includes('learning_')
      );
      
      userSpecificSessionKeys.forEach(key => {
        try {
          sessionStorage.removeItem(key);
        } catch (e) {
          // Ignore individual key removal errors
        }
      });
    } catch (e) {
      // Ignore errors when reading sessionStorage keys
    }
    
  } catch (error) {
    console.error('Error clearing auth data:', error);
  }
}

// Force clear auth state and reload page (for critical auth issues)
export function forceAuthReset() {
  clearAllAuthData();
  
  // Additional aggressive clearing for critical issues
  try {
    // Clear all localStorage
    localStorage.clear();
    // Clear all sessionStorage  
    sessionStorage.clear();
  } catch (error) {
    console.error('Error during force clear:', error);
  }
  
  // Small delay to ensure storage is cleared before reload
  setTimeout(() => {
    window.location.href = '/login';
  }, 100);
}
